import { SalaryType } from '@/lib/generated/graphql-types'

export enum SalaryVisibility {
  Restricted = 'restricted',
  None = 'none',
  All = 'all',
}

export enum WorkStatus {
  Fellow = 'fellow',
  Resident = 'resident',
  InTraining = 'inTraining',
  Practicing = 'practicing',
}

export const SEE_MORE_ROW_HINT = 'seeMoreRowHint'
export const SALARY_ROW_SELECTOR = 'salary-row-'
export enum SalaryPayPeriod {
  Hourly = 'hourly',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Annually = 'annually',
}

/**
 * @param onRowClick - if provided, the table will call this function when a row is clicked.
 */
export type SalaryRowsProps = {
  salaries: SalaryType[]
  isShowingSalaryDetails?: boolean
  blurTotalCompensation?: boolean
  onRowClick?: (salary: SalaryType) => void
  className?: string
  canClickOnRowOverride?: boolean
  showTableRowHint?: boolean
}
